import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor () { }
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const reRgId = sessionStorage.getItem('ReRgId');
    const headers:Record<string, string> = {};
    if (reRgId) headers['X-ReRgId'] = reRgId;
    request = request.clone({
      withCredentials: true,
      setHeaders: headers
    });
    return next.handle(request);
  }
}